import {ManualKpi, ManualKpiToUpdate} from '../types'

export const generateKpi = (data: Partial<ManualKpiToUpdate>): ManualKpiToUpdate => ({
  name: data.name ?? '',
  unit: data.unit ?? '',
  processStage: data.processStage ?? ''
})

export const generateKpisToUpdate = (data: ManualKpi[]): ManualKpiToUpdate[] =>
  data.map((kpi) => ({
    name: kpi.name,
    unit: kpi.unit,
    processStage: kpi.processStage,
    id: kpi.id,
    concurrencyStamp: kpi.concurrencyStamp,
    actualValue: kpi.actualValue,
    plannedValue: kpi.plannedValue,
    delta: kpi.delta
  }))
